import { TrainingOptionsFields } from '../training/training-options/Type';
import { Module } from '../../types/AgilityTypes';
import TrainingOptionsMain from '../training/training-options/TrainingOptionsMain';

const TrainingOptions = ({
  module,
}: {
  module: Module<TrainingOptionsFields>;
}) => {
  if (!module || !module.fields) {
    return null;
  }

  const mainTitleStyle = module.fields?.titleStyle
    ? {
        level: module.fields.titleStyle.fields?.level ?? 1,
        color: module.fields.titleStyle.fields?.color || '#fff',
      }
    : undefined;
  return (
    <TrainingOptionsMain
      mainTitle={module.fields?.title}
      mainTitleStyle={mainTitleStyle}
      specificTrainings={module.fields?.specificTrainings}
      commonComponent={Array.isArray(module.fields?.commonComponent) ? module.fields.commonComponent[0] : module.fields?.commonComponent}
      backgroundStyle={module.fields?.backgroundStyle}
    />
  );
};

export default TrainingOptions;
